import {
  ContactCardFirstTextState,
  TwilioPhoneVerificationStatus,
} from "@markit/common.types";
import { Colors } from "../../../utils/colors";
import { useDispatch, useSelector } from "react-redux";
import {
  changeBypassQuietHours,
  changeToggleContactCardFirstText,
  getAccountState,
} from "../../../redux/slices/accountSlice";
import StandardBorderedContainer from "../../Containers/StandardBorderedContainer";
import SwitchToggleItem from "../../SwitchToggleItem";
import { useCallback, useContext, useMemo, useState } from "react";
import { MixpanelContext } from "../../../context/AnalyticsService";
import {
  hasSubscription,
  userPhoneVerificationStatus,
} from "@markit/common.utils";
import QuietHoursDisableModal from "../MassTexts/QuietHours/QuietHoursDisableModal";

const TextingSettingsPanel = () => {
  const { accountData } = useSelector(getAccountState).account;
  const mixpanel = useContext(MixpanelContext);
  const dispatch = useDispatch();
  const [showDisableQuietHoursModal, setShowDisableQuietHoursModal] =
    useState(false);

  const styles = {
    sectionContainer: {
      padding: 14,
      backgroundColor: Colors.WHITE,
      width: 400,
    },
  };

  const approvedAccountStatus = useMemo(
    () =>
      hasSubscription(accountData) &&
      userPhoneVerificationStatus(accountData) ===
        TwilioPhoneVerificationStatus.APPROVED,
    [accountData]
  );

  const toggleContactCardSetting = useCallback(() => {
    const newToggleState =
      accountData.toggleContactCardFirstText !==
      ContactCardFirstTextState.ENABLED
        ? ContactCardFirstTextState.ENABLED
        : ContactCardFirstTextState.DISABLED;

    mixpanel.track("Toggled Contact Card First Text", {
      distinct_id: accountData.uid,
      from: "webapp",
      toggle_state: newToggleState,
    });

    dispatch(changeToggleContactCardFirstText(accountData.uid, newToggleState));
  }, [
    accountData.toggleContactCardFirstText,
    accountData.uid,
    dispatch,
    mixpanel,
  ]);

  const toggleBypassQuietHours = useCallback(() => {
    if (!accountData.bypassQuietHours) {
      setShowDisableQuietHoursModal(true);
    } else {
      dispatch(changeBypassQuietHours(accountData.uid, false, mixpanel));
    }
  }, [accountData.bypassQuietHours, accountData.uid, dispatch, mixpanel]);

  return (
    <div className="AlignedRow" style={{ gap: 30 }}>
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <span className="sectionTitle">Text Defaults</span>
        <StandardBorderedContainer containerStyles={styles.sectionContainer}>
          <SwitchToggleItem
            title="Add Contact Card for First-Time Recipients"
            description={
              approvedAccountStatus
                ? "Automatically adds a contact card to the first text sent to a new recipient. This uses 3 additional credits per recipient."
                : "Available with approved Markit+ account."
            }
            toggleValue={
              accountData.toggleContactCardFirstText ===
              ContactCardFirstTextState.ENABLED
            }
            onChange={toggleContactCardSetting}
            disabled={!approvedAccountStatus}
          />
        </StandardBorderedContainer>
      </div>
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <span className="sectionTitle">Quiet Hours</span>
        <StandardBorderedContainer containerStyles={styles.sectionContainer}>
          <SwitchToggleItem
            title="Enforce Quiet Hours"
            description={
              "As per SMS guidelines, marketing messages are not allowed to be sent between 7:30pm - 8:00am. Disabling bypasses this restriction."
            }
            toggleValue={!accountData.bypassQuietHours}
            onChange={toggleBypassQuietHours}
          />
        </StandardBorderedContainer>
      </div>
      {showDisableQuietHoursModal ? (
        <QuietHoursDisableModal setIsVisible={setShowDisableQuietHoursModal} />
      ) : null}
    </div>
  );
};

export default TextingSettingsPanel;
